import { Component } from '@angular/core';
import { Model } from '../app.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-integration-apps',
  templateUrl: 'integration-apps.component.html',
  standalone: false
})
export class IntegrationAppsComponent {

  constructor(private m: Model,
    private router: Router) {
    if(!this.m.account.isIntegrationAppsBetaUser) {
      this.router.navigate(['/']);
    }
  }

}
